var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "AutoHandoverInbound"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "cargo",
      "id": "cargo",
      "value": "cargo"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "cargo")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "cargo"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "cargo"
    }
  }, [_vm._v("Cargo")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "ecom",
      "id": "ecom",
      "value": "ecom"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "ecom")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "ecom"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "ecom"
    }
  }, [_vm._v("Ecom")])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.checkedType == 'cargo') ? _c('div', {
    staticClass: "rows"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchBatchNo()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.batchNo),
      expression: "batchNo"
    }],
    ref: "batchNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Paper Bag no/Batch No",
      "name": "batchNo",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.batchNo)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.batchNo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.batchNoErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.batchNoErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sno")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paper Bag No ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch No ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created At")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total AWBs")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Phy/Vol Wt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Creation Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Scan Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.BatchData.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.BatchData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdAt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.AWBcount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.bmodalopen(data)
        }
      }
    }, [_c('b', [_vm._v("\n                        " + _vm._s(data.MPScount) + "\n                      ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TotalPhysicalWeight) + "/" + _vm._s(data.TotalVolumetricWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdtime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isDualScanEnabled) ? _c('span', {
      staticClass: "hub8058-scan-mode-badge"
    }, [_vm._v("Dual")]) : _c('span', {
      staticClass: "hub8058-scan-mode-auto"
    }, [_vm._v("Auto")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.status == 'OutScan') ? _c('button', {
      staticClass: "btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openInscanCard(data)
        }
      }
    }, [_vm._v("Inscan")]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('br')], 1)]) : _vm._e(), _vm._v(" "), (_vm.checkedType == 'ecom') ? _c('div', {
    staticClass: "rows"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchBatchNo()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.batchNo),
      expression: "batchNo"
    }],
    ref: "batchNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Batch No",
      "name": "batchNo"
    },
    domProps: {
      "value": (_vm.batchNo)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.batchNo = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.batchNoErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.batchNoErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sno")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch No ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created At")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Zone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Phy/Vol Wt")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Creation Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Scan Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.BatchData.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.BatchData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdAt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.zone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "rgb(25,25,112)",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.bmodalopenecom(data)
        }
      }
    }, [_c('b', [_vm._v("\n                        " + _vm._s(data.Bagcount) + "\n                      ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TotalPhysicalWeight) + "/" + _vm._s(data.TotalVolumetricWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdtime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.isDualScanEnabled) ? _c('span', {
      staticClass: "hub8058-scan-mode-badge"
    }, [_vm._v("Dual")]) : _c('span', {
      staticClass: "hub8058-scan-mode-auto"
    }, [_vm._v("Auto")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.status == 'OutScan') ? _c('button', {
      staticClass: "btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.getObsoleteBags(data)
        }
      }
    }, [_vm._v("Inscan")]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('br')], 1)]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("MPS Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.bmodalclose()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS Details")])])]), _vm._v(" "), _c('tbody', [(_vm.mpsdata.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "1",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.mpsdata), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpsid))])])
  })], 2)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShowecom),
      callback: function($$v) {
        _vm.modalShowecom = $$v
      },
      expression: "modalShowecom"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.bmodalcloseecom()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Details")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Name")])])]), _vm._v(" "), _c('tbody', [(_vm.bagdata.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bagdata), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupname))])])
  })], 2)]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 10),
      expression: "totalCount>10"
    }],
    ref: "paginate",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 10,
      "margin-pages": 10,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Inscanbag"
    },
    model: {
      value: (_vm.IsInscanBag),
      callback: function($$v) {
        _vm.IsInscanBag = $$v
      },
      expression: "IsInscanBag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Inscan Paper bag and AWB")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeInscanCard
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Batch NO :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("\n                            " + _vm._s(this.batchinscan) + "\n                          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBag
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBag = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Paper Bag")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PaperBagbarcode),
      expression: "PaperBagbarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "PaperBagbarcode",
    class: {
      'form-control': true, 'error': _vm.errors.has('PaperBagbarcode')
    },
    attrs: {
      "type": "text",
      "name": "PaperBagbarcode",
      "placeholder": "Scan paper bag"
    },
    domProps: {
      "value": (_vm.PaperBagbarcode)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "change": _vm.inscanBag,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PaperBagbarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.PaperBagErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.PaperBagErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.inscanBag
    }
  }, [_vm._v("Inscan")])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingAWB
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingAWB = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWBs")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBsbarcode),
      expression: "AWBsbarcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "AWBsbarcode",
    class: {
      'form-control': true, 'error': _vm.errors.has('AWBsbarcode')
    },
    attrs: {
      "type": "text",
      "name": "AWBsbarcode",
      "placeholder": "Scan AWBs"
    },
    domProps: {
      "value": (_vm.AWBsbarcode)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "change": _vm.inscanAwbpaper,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBsbarcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AWBsbarcode')),
      expression: "errors.has('AWBsbarcode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" AWBsbarcode is required.")]), _vm._v(" "), (_vm.AWBsErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.AWBsErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    staticStyle: {
      "height": "35px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.inscanAwbpaper
    }
  }, [_vm._v("Inscan")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWBs   ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "25px"
    }
  }, [_vm._v("Inscan")])])]), _vm._v(" "), _c('tbody', [(_vm.ParentAWBDetails.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ParentAWBDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawb))]), _vm._v(" "), (data.inscandone == true) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "25px"
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "bar-fade-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBagsorAwbs
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBagsorAwbs = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "common-success btn btn-secondary",
    staticStyle: {
      "height": "35px"
    },
    style: ((_vm.disablescanInBtn == true) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "disabled": _vm.disablescanInBtn,
      "type": "submit"
    },
    on: {
      "click": _vm.getObsoleteAwbs
    }
  }, [_vm._v("Confirm")]), _vm._v("  \n                          "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetinscan
    }
  }, [_vm._v("Cancel")])], 1)], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.ConfirmationModalinscan),
      callback: function($$v) {
        _vm.ConfirmationModalinscan = $$v
      },
      expression: "ConfirmationModalinscan"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeConfirmationModalinscan
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.obseleteFlag) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "color": "rgb(11, 12, 12)"
    }
  }, [_vm._v("Please verify if " + _vm._s(this.UpdatedBatchMpsCount) + " MPS have been handed over from this batch. Do you want to continue inscan? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "rgb(11, 12, 12)"
    }
  }, [_vm._v("Parent Awb count removed from this batch : " + _vm._s(this.ObsoleteAWBCount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "rgb(11, 12, 12)"
    }
  }, [_vm._v("Note : This is due to inscan/Partial inscan at other location")])]) : _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "color": "rgb(19, 18, 18)"
    }
  }, [_vm._v("Please verify if " + _vm._s(this.MPScount) + " MPS or Shipment have been handed from this batch. Do you want to continue inscan? ")])]), _vm._v(" "), (_vm.obseleteFlag) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")])])]), _vm._v(" "), _c('tbody', [(_vm.obsoleteAwbsList.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "1",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.obsoleteAwbsList), function(d, i) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(d))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.showConfirminscan) ? _c('b-button', {
    staticClass: "common-success",
    style: ((_vm.isCountZero == true) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "button",
      "disabled": _vm.isCountZero
    },
    on: {
      "click": _vm.ahbatchIncan
    }
  }, [_vm._v("InScan")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": [_vm.closeConfirmationModalinscan, _vm.resetForm]
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  })])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.Confirmationecom),
      callback: function($$v) {
        _vm.Confirmationecom = $$v
      },
      expression: "Confirmationecom"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeInscanCardecom
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.obseleteFlag) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "color": "rgb(11, 12, 12)"
    }
  }, [_vm._v("Please verify if " + _vm._s(this.updatedBagCount) + "/" + _vm._s(this.updatedBagCount + this.obsoleteCount) + " bags have been handed over from this batch. Do you want to continue inscan? ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "rgb(11, 12, 12)"
    }
  }, [_vm._v("Bag Count at other locations: " + _vm._s(this.obsoleteCount) + " ")])]) : _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "color": "rgb(11, 12, 12)"
    }
  }, [_vm._v("Please verify if " + _vm._s(this.Bagcount) + " bags have been handed from this batch. Do you want to continue inscan? ")])]), _vm._v(" "), (_vm.obseleteFlag) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Location")])])]), _vm._v(" "), _c('tbody', [(_vm.obsoletebagData.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.obsoletebagData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubid))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.showConfirmecom) ? _c('b-button', {
    staticClass: "common-success",
    style: ((_vm.isCountZero == true) ? 'opacity: 0.8; cursor: not-allowed;' : ''),
    attrs: {
      "type": "button",
      "disabled": _vm.isCountZero
    },
    on: {
      "click": _vm.AutoHandoverInscanB2C
    }
  }, [_vm._v("InScan")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": [_vm.closeInscanCardecom, _vm.resetForm]
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  })])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "dialog-class": "hub8058-dual-scan-dialog",
      "title": "DualScanEcom",
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    model: {
      value: (_vm.dualScanEcomOpen),
      callback: function($$v) {
        _vm.dualScanEcomOpen = $$v
      },
      expression: "dualScanEcomOpen"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Combo Hub - Dual Scan")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDualScanEcom
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm hub8058-modal-body"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v("Batch NO :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_vm._v(_vm._s(_vm.dualScanBatchId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v("Expected bags :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_vm._v(_vm._s(_vm.dualScanExpectedCount))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Scan Bag number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dualScanBagInput),
      expression: "dualScanBagInput"
    }],
    ref: "dualScanBagInput",
    staticClass: "form-control hub8058-scan-input",
    attrs: {
      "type": "text",
      "name": "dualScanBagInput",
      "placeholder": "Scan Bag number",
      "autocomplete": "off",
      "disabled": _vm.dualScanScanBusy || _vm.dualScanCounters.PendingCount === 0
    },
    domProps: {
      "value": (_vm.dualScanBagInput)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "change": _vm.scanBagDual,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dualScanBagInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.dualScanBagError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.dualScanBagError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "hub8058-counters"
  }, [_c('span', {
    staticClass: "hub8058-counter-scanned"
  }, [_vm._v("Scanned: " + _vm._s(_vm.dualScanCounters.ScannedCount) + " / " + _vm._s(_vm.dualScanCounters.TotalActive))]), _vm._v(" "), (_vm.dualScanCounters.ShortageCount > 0) ? _c('span', {
    staticClass: "hub8058-counter-shortage"
  }, [_vm._v(_vm._s(_vm.dualScanCounters.ShortageCount) + " shortage")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "hub8058-counter-pending"
  }, [_vm._v(_vm._s(_vm.dualScanCounters.PendingCount) + " pending")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.dualScanListLoading
    },
    on: {
      "update:active": function($event) {
        _vm.dualScanListLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hub8058-scan-list"
  }, [(_vm.dualScanBags.length === 0 && !_vm.dualScanListLoading) ? _c('div', {
    staticClass: "hub8058-empty"
  }, [_vm._v("No bags to scan")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dualScanBags), function(bag, idx) {
    return _c('label', {
      key: bag.bagno,
      staticClass: "hub8058-row",
      class: {
        'hub8058-row--scanned': bag.status === 'InScan',
          'hub8058-row--shortage': bag.status === 'BagShortage',
          'hub8058-row--pending': bag.status === 'Pending',
          'hub8058-row--selected': _vm.selectedShortageRow === idx && bag.status === 'Pending'
      }
    }, [(bag.status === 'Pending') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedShortageRow),
        expression: "selectedShortageRow"
      }],
      staticClass: "hub8058-row-radio",
      attrs: {
        "type": "radio",
        "name": "hub8058-bag-radio"
      },
      domProps: {
        "value": idx,
        "checked": _vm._q(_vm.selectedShortageRow, idx)
      },
      on: {
        "change": function($event) {
          _vm.selectedShortageRow = idx
        }
      }
    }) : _c('span', {
      staticClass: "hub8058-row-radio-spacer",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-primary"
    }, [_vm._v(_vm._s(bag.bagno))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-status"
    }, [(bag.status === 'InScan') ? _c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (bag.status === 'InScan') ? _c('span', [_vm._v("Scanned")]) : (bag.status === 'BagShortage') ? _c('span', {
      attrs: {
        "title": _vm.shortageReasonLabel(bag.comment)
      }
    }, [_vm._v("Shortage")]) : _c('span', [_vm._v("Pending")])])])
  })], 2), _vm._v(" "), (_vm.dualScanAutoConfirmedMsg) ? _c('div', {
    staticClass: "hub8058-autoconfirm-banner",
    attrs: {
      "role": "status"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dualScanAutoConfirmedMsg))])]) : _vm._e(), _vm._v(" "), (_vm.shortageModalOpen && _vm.shortageMode === 'ecom') ? _c('div', {
    staticClass: "hub8058-shortage-panel"
  }, [_c('div', {
    staticClass: "hub8058-shortage-panel-header"
  }, [_vm._v("\n                    Mark shortage — "), _c('strong', [_vm._v(_vm._s(_vm.shortageContext && _vm.shortageContext.bagno))])]), _vm._v(" "), _c('div', {
    staticClass: "hub8058-shortage-panel-body"
  }, [_c('label', [_vm._v("Reason")]), _vm._v(" "), (_vm.shortageReasonsFetching) ? _c('div', {
    staticClass: "hub8058-shortage-loading"
  }, [_vm._v("\n                      Loading reasons…\n                    ")]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortageReasonCode),
      expression: "shortageReasonCode"
    }],
    staticClass: "form-control hub8058-shortage-reason",
    attrs: {
      "disabled": !_vm.shortageReasonsLoaded || _vm.shortageReasonsError || _vm.shortageSaveBusy
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shortageReasonCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select reason")]), _vm._v(" "), _vm._l((_vm.shortageReasons), function(r) {
    return _c('option', {
      key: r.code,
      domProps: {
        "value": r.code
      }
    }, [_vm._v(_vm._s(r.label))])
  })], 2), _vm._v(" "), (_vm.shortageReasonsError) ? _c('div', {
    staticClass: "hub8058-shortage-error"
  }, [_vm._v("\n                      Reason list unavailable.\n                      "), _c('b-button', {
    attrs: {
      "variant": "link",
      "size": "sm",
      "disabled": _vm.shortageSaveBusy || _vm.shortageReasonsFetching
    },
    on: {
      "click": _vm.retryFetchShortageReasons
    }
  }, [_vm._v("Retry")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hub8058-modal-footer"
  }, [(_vm.shortageModalOpen && _vm.shortageMode === 'ecom') ? [_c('button', {
    staticClass: "btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.shortageSaveBusy
    },
    on: {
      "click": _vm.closeShortageModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "common-success btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.shortageReasonCode || _vm.shortageSaveBusy || _vm.shortageReasonsError
    },
    on: {
      "click": _vm.saveShortage
    }
  }, [_vm._v("Save shortage")])] : [_c('button', {
    staticClass: "common-success btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.selectedShortageRow === null || _vm.dualScanBags[_vm.selectedShortageRow] === undefined || _vm.dualScanBags[_vm.selectedShortageRow].status !== 'Pending'
    },
    on: {
      "click": function($event) {
        return _vm.openShortageModal('ecom')
      }
    }
  }, [_vm._v("Mark shortage")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeDualScanEcom
    }
  }, [_vm._v("Close")])]], 2)], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "dialog-class": "hub8058-dual-scan-dialog",
      "title": "DualScanCargo",
      "hide-header": "",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    model: {
      value: (_vm.dualScanCargoOpen),
      callback: function($$v) {
        _vm.dualScanCargoOpen = $$v
      },
      expression: "dualScanCargoOpen"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Combo Hub - Dual Scan - Cargo")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDualScanCargo
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm hub8058-modal-body"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v("Batch NO :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_vm._v(_vm._s(_vm.dualScanBatchId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('label', [_vm._v("Expected MPS :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_vm._v(_vm._s(_vm.dualScanExpectedCount))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Paper Bag")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dualScanPaperbagInput),
      expression: "dualScanPaperbagInput"
    }],
    ref: "dualScanPaperbagInput",
    staticClass: "form-control hub8058-scan-input",
    attrs: {
      "type": "text",
      "placeholder": "Scan paper bag",
      "autocomplete": "off",
      "disabled": _vm.isLoadingBag || !!_vm.PaperBagNo
    },
    domProps: {
      "value": (_vm.dualScanPaperbagInput)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "change": _vm.scanPaperbagDual,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dualScanPaperbagInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.dualScanPaperbagError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.dualScanPaperbagError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Scan Parent AWB")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dualScanAwbInput),
      expression: "dualScanAwbInput"
    }],
    ref: "dualScanAwbInput",
    staticClass: "form-control hub8058-scan-input",
    attrs: {
      "type": "text",
      "placeholder": "Scan AWBs — repeat as needed",
      "autocomplete": "off",
      "disabled": !_vm.PaperBagNo || _vm.isLoadingAWB
    },
    domProps: {
      "value": (_vm.dualScanAwbInput)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "change": _vm.scanAwbDual,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dualScanAwbInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.dualScanAwbError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.dualScanAwbError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Scan MPS number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dualScanMpsInput),
      expression: "dualScanMpsInput"
    }],
    ref: "dualScanMpsInput",
    staticClass: "form-control hub8058-scan-input",
    attrs: {
      "type": "text",
      "placeholder": "Scan MPS — any order",
      "autocomplete": "off",
      "disabled": !_vm.PaperBagNo || _vm.dualScanScanBusy
    },
    domProps: {
      "value": (_vm.dualScanMpsInput)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "change": _vm.scanMpsDual,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dualScanMpsInput = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.dualScanMpsError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.dualScanMpsError))]) : _vm._e()], 1), _vm._v(" "), (_vm.PaperBagNo) ? [_c('div', {
    staticClass: "hub8058-counters"
  }, [_c('span', {
    staticClass: "hub8058-counter-scanned"
  }, [_vm._v("Scanned: " + _vm._s(_vm.dualScanCounters.ScannedCount) + " / " + _vm._s(_vm.dualScanCounters.TotalActive))]), _vm._v(" "), (_vm.dualScanCounters.ShortageCount > 0) ? _c('span', {
    staticClass: "hub8058-counter-shortage"
  }, [_vm._v(_vm._s(_vm.dualScanCounters.ShortageCount) + " shortage")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "hub8058-counter-pending"
  }, [_vm._v(_vm._s(_vm.dualScanCounters.PendingCount) + " pending")])]), _vm._v(" "), _c('div', {
    staticClass: "hub8058-main-tabs"
  }, [_c('button', {
    staticClass: "hub8058-main-tab",
    class: {
      'hub8058-main-tab--active': _vm.dualScanCargoMainTab === 'parent-awbs'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDualScanCargoMainTab('parent-awbs')
      }
    }
  }, [_vm._v("Parent AWBs")]), _vm._v(" "), _c('button', {
    staticClass: "hub8058-main-tab",
    class: {
      'hub8058-main-tab--active': _vm.dualScanCargoMainTab === 'mps'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDualScanCargoMainTab('mps')
      }
    }
  }, [_vm._v("MPS")])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.dualScanListLoading
    },
    on: {
      "update:active": function($event) {
        _vm.dualScanListLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.dualScanCargoMainTab === 'parent-awbs') ? _c('div', {
    staticClass: "hub8058-awb-list"
  }, [(_vm.dualScanAwbGroups.length === 0 && !_vm.dualScanListLoading) ? _c('div', {
    staticClass: "hub8058-empty"
  }, [_vm._v("No parent AWBs loaded")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dualScanAwbGroups), function(grp) {
    return _c('div', {
      key: grp.parentawb,
      staticClass: "hub8058-awb-accordion"
    }, [_c('div', {
      staticClass: "hub8058-awb-header",
      on: {
        "click": function($event) {
          return _vm.toggleAwbAccordion(grp.parentawb)
        }
      }
    }, [_c('span', {
      staticClass: "hub8058-awb-title"
    }, [_vm._v("Parent AWB: " + _vm._s(grp.parentawb))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-awb-status",
      class: {
        'hub8058-awb-status--in': grp.parentawbstatus === 'InScan', 'hub8058-awb-status--out': grp.parentawbstatus !== 'InScan'
      }
    }, [_vm._v(_vm._s(grp.parentawbstatus))]), _vm._v(" "), _c('i', {
      staticClass: "fa",
      class: _vm.dualScanExpandedAwb === grp.parentawb ? 'fa-chevron-up' : 'fa-chevron-down',
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), _vm._v(" "), _c('p', {
    staticClass: "hub8058-tab-hint"
  }, [_vm._v("Use the scan fields above. This tab is for AWB paperwork verification.")])], 2) : _vm._e(), _vm._v(" "), (_vm.dualScanCargoMainTab === 'mps') ? _c('div', [_c('div', {
    staticClass: "hub8058-status-tabs"
  }, [_c('button', {
    staticClass: "hub8058-status-tab",
    class: {
      'hub8058-status-tab--active': _vm.dualScanMpsListTab === 'pending'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDualScanMpsListTab('pending')
      }
    }
  }, [_vm._v("Pending (" + _vm._s(_vm.dualScanCounters.PendingCount) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "hub8058-status-tab",
    class: {
      'hub8058-status-tab--active': _vm.dualScanMpsListTab === 'scanned'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDualScanMpsListTab('scanned')
      }
    }
  }, [_vm._v("Scanned (" + _vm._s(_vm.dualScanCounters.ScannedCount) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "hub8058-status-tab",
    class: {
      'hub8058-status-tab--active': _vm.dualScanMpsListTab === 'shortage'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setDualScanMpsListTab('shortage')
      }
    }
  }, [_vm._v("Shortage (" + _vm._s(_vm.dualScanCounters.ShortageCount) + ")")])]), _vm._v(" "), (_vm.dualScanMpsListTab === 'pending') ? _c('div', {
    ref: "dualScanMpsList",
    staticClass: "hub8058-scan-list",
    on: {
      "scroll": _vm.onDualScanMpsListScroll
    }
  }, [(_vm.dualScanMpsFiltered.length === 0 && !_vm.dualScanListLoading) ? _c('div', {
    staticClass: "hub8058-empty"
  }, [_vm._v("No pending MPS")]) : _vm._e(), _vm._v(" "), (_vm.dualScanMpsUseWindow) ? _c('div', {
    style: ({
      height: _vm.dualScanMpsTopSpacerPx + 'px'
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.dualScanMpsWindowedRows), function(mps) {
    return _c('label', {
      key: _vm.mpsRowKey(mps),
      staticClass: "hub8058-row hub8058-row--mps",
      class: {
        'hub8058-row--pending': mps.status === 'Pending',
          'hub8058-row--selected': _vm.selectedMpsKey === _vm.mpsRowKey(mps)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMpsKey),
        expression: "selectedMpsKey"
      }],
      staticClass: "hub8058-row-radio",
      attrs: {
        "type": "radio",
        "name": "hub8058-mps-radio"
      },
      domProps: {
        "value": _vm.mpsRowKey(mps),
        "checked": _vm._q(_vm.selectedMpsKey, _vm.mpsRowKey(mps))
      },
      on: {
        "change": function($event) {
          _vm.selectedMpsKey = _vm.mpsRowKey(mps)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-primary"
    }, [_vm._v(_vm._s(mps.mpsid))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-awb",
      class: {
        'hub8058-row-awb--ready': mps.parentawbstatus === 'InScan', 'hub8058-row-awb--blocked': mps.parentawbstatus !== 'InScan'
      }
    }, [_vm._v("AWB " + _vm._s(mps.parentawb))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-status"
    }, [_vm._v("Pending")])])
  }), _vm._v(" "), (_vm.dualScanMpsUseWindow) ? _c('div', {
    style: ({
      height: _vm.dualScanMpsBottomSpacerPx + 'px'
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.dualScanMpsListTab === 'scanned' && _vm.dualScanMpsScannedMounted) ? _c('div', {
    staticClass: "hub8058-scan-list"
  }, [(_vm.dualScanMpsFiltered.length === 0) ? _c('div', {
    staticClass: "hub8058-empty"
  }, [_vm._v("No scanned MPS")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dualScanMpsFiltered), function(mps) {
    return _c('div', {
      key: _vm.mpsRowKey(mps),
      staticClass: "hub8058-row hub8058-row--mps hub8058-row--scanned"
    }, [_c('span', {
      staticClass: "hub8058-row-radio-spacer",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-primary"
    }, [_vm._v(_vm._s(mps.mpsid))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-awb hub8058-row-awb--ready"
    }, [_vm._v("AWB " + _vm._s(mps.parentawb))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-status"
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Scanned\n                      ")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.dualScanMpsListTab === 'shortage' && _vm.dualScanMpsShortageMounted) ? _c('div', {
    staticClass: "hub8058-scan-list"
  }, [(_vm.dualScanMpsFiltered.length === 0) ? _c('div', {
    staticClass: "hub8058-empty"
  }, [_vm._v("No shortage MPS")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dualScanMpsFiltered), function(mps) {
    return _c('div', {
      key: _vm.mpsRowKey(mps),
      staticClass: "hub8058-row hub8058-row--mps hub8058-row--shortage"
    }, [_c('span', {
      staticClass: "hub8058-row-radio-spacer",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-primary"
    }, [_vm._v(_vm._s(mps.mpsid))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-awb"
    }, [_vm._v("AWB " + _vm._s(mps.parentawb))]), _vm._v(" "), _c('span', {
      staticClass: "hub8058-row-status",
      attrs: {
        "title": _vm.shortageReasonLabel(mps.comment)
      }
    }, [_vm._v("Shortage")])])
  })], 2) : _vm._e()]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.dualScanAutoConfirmedMsg) ? _c('div', {
    staticClass: "hub8058-autoconfirm-banner",
    attrs: {
      "role": "status"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dualScanAutoConfirmedMsg))])]) : _vm._e(), _vm._v(" "), (_vm.shortageModalOpen && _vm.shortageMode === 'cargo') ? _c('div', {
    staticClass: "hub8058-shortage-panel"
  }, [_c('div', {
    staticClass: "hub8058-shortage-panel-header"
  }, [_vm._v("\n                    Mark shortage — "), _c('strong', [_vm._v(_vm._s(_vm.shortageContext && _vm.shortageContext.mpsid))]), _vm._v(" "), (_vm.shortageContext) ? _c('span', {
    staticClass: "hub8058-shortage-panel-subheader"
  }, [_vm._v("under AWB " + _vm._s(_vm.shortageContext.parentawb))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hub8058-shortage-panel-body"
  }, [_c('label', [_vm._v("Reason")]), _vm._v(" "), (_vm.shortageReasonsFetching) ? _c('div', {
    staticClass: "hub8058-shortage-loading"
  }, [_vm._v("\n                      Loading reasons…\n                    ")]) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortageReasonCode),
      expression: "shortageReasonCode"
    }],
    staticClass: "form-control hub8058-shortage-reason",
    attrs: {
      "disabled": !_vm.shortageReasonsLoaded || _vm.shortageReasonsError || _vm.shortageSaveBusy
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shortageReasonCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select reason")]), _vm._v(" "), _vm._l((_vm.shortageReasons), function(r) {
    return _c('option', {
      key: r.code,
      domProps: {
        "value": r.code
      }
    }, [_vm._v(_vm._s(r.label))])
  })], 2), _vm._v(" "), (_vm.shortageReasonsError) ? _c('div', {
    staticClass: "hub8058-shortage-error"
  }, [_vm._v("\n                      Reason list unavailable.\n                      "), _c('b-button', {
    attrs: {
      "variant": "link",
      "size": "sm",
      "disabled": _vm.shortageSaveBusy || _vm.shortageReasonsFetching
    },
    on: {
      "click": _vm.retryFetchShortageReasons
    }
  }, [_vm._v("Retry")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hub8058-modal-footer"
  }, [(_vm.shortageModalOpen && _vm.shortageMode === 'cargo') ? [_c('button', {
    staticClass: "btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.shortageSaveBusy
    },
    on: {
      "click": _vm.closeShortageModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "common-success btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.shortageReasonCode || _vm.shortageSaveBusy || _vm.shortageReasonsError
    },
    on: {
      "click": _vm.saveShortage
    }
  }, [_vm._v("Save shortage")])] : [_c('button', {
    staticClass: "common-success btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.selectedMpsKey === null || _vm.dualScanCargoMainTab !== 'mps' || _vm.dualScanMpsListTab !== 'pending'
    },
    on: {
      "click": function($event) {
        return _vm.openShortageModal('cargo')
      }
    }
  }, [_vm._v("Mark shortage")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary hub8058-footer-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeDualScanCargo
    }
  }, [_vm._v("Close")])]], 2)], 2)])])])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e007757","hasScoped":true}!./src/views/components/AutoHandover_v1/Inbound/Inbound.html
// module id = 1793
// module chunks = 2